import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './supporting-content-card.component.scss';
var SupportingContentCard = /** @class */ (function (_super) {
    tslib_1.__extends(SupportingContentCard, _super);
    function SupportingContentCard(element) {
        return _super.call(this, element) || this;
    }
    SupportingContentCard.prototype.init = function () { };
    ;
    SupportingContentCard.prototype.bindEvents = function () { };
    ;
    return SupportingContentCard;
}(Base));
export { SupportingContentCard };



//////////////////
// WEBPACK FOOTER
// ./components/supporting-content-card/supporting-content-card.component.ts
// module id = 517
// module chunks = 0